import { MapUtils } from '../../../utility/map-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../dto/data-model.js';
import { LocalizedString } from '../localized-string.js';
import { Price } from '../price.js';

export class AnalyticsCartItemDto extends DataModel {
  static readonly TYPE_ID: string = '21ff46af79814e6b8f76a3177d20725a';

  private constructor(
      public readonly uniqueId: string,
      public readonly name: LocalizedString,
      public readonly unitPrice: Price,
      public readonly quantity: number,
      public readonly totalPrice: Price,
  ) {super();}

  static create(args: {
      uniqueId: string,
      name: LocalizedString,
      unitPrice: Price,
      quantity: number,
      totalPrice: Price,
    }): AnalyticsCartItemDto {
    return new AnalyticsCartItemDto(
        args.uniqueId,
        args.name,
        args.unitPrice,
        args.quantity,
        args.totalPrice);
  }

  public static fromMap(context: SerializationContext, map: SerializedData) {
    return new AnalyticsCartItemDto(
        MapUtils.getString(map, 'uniqueId'),
        context.fromData(MapUtils.getRecord(map, 'name')),
        Price.decode(MapUtils.getString(map, 'unitPrice')),
        MapUtils.getInteger(map, 'quantity'),
        Price.decode(MapUtils.getString(map, 'totalPrice'))
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'uniqueId': this.uniqueId,
      'name': context.toData(this.name),
      'unitPrice': this.unitPrice.encode(),
      'quantity': this.quantity,
      'totalPrice': this.totalPrice.encode(),
    };
  }

  clone(): this {
    return new AnalyticsCartItemDto(
        this.uniqueId,
        this.name,
        this.unitPrice,
        this.quantity,
        this.totalPrice
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return this.uniqueId === other.uniqueId &&
      this.name === other.name &&
      this.unitPrice === other.unitPrice &&
      this.quantity === other.quantity &&
      this.totalPrice === other.totalPrice;
  }

  get $typeId(): string {
    return AnalyticsCartItemDto.TYPE_ID;
  }
}

export class AnalyticsCartItemDtoBuilder extends DataModelBuilder<AnalyticsCartItemDto> {
  build(context: SerializationContext, map: SerializedData): AnalyticsCartItemDto {
    return AnalyticsCartItemDto.fromMap(context, map);
  }
}
